var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpathy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 56.73V51.3966C16 48.5677 17.1238 45.8546 19.1242 43.8542C21.1246 41.8538 23.8377 40.73 26.6667 40.73H28M21.3333 19.3966C21.3333 22.2256 22.4571 24.9387 24.4575 26.9391C26.4579 28.9395 29.171 30.0633 32 30.0633C34.829 30.0633 37.5421 28.9395 39.5425 26.9391C41.5429 24.9387 42.6667 22.2256 42.6667 19.3966C42.6667 16.5677 41.5429 13.8546 39.5425 11.8542C37.5421 9.85379 34.829 8.72998 32 8.72998C29.171 8.72998 26.4579 9.85379 24.4575 11.8542C22.4571 13.8546 21.3333 16.5677 21.3333 19.3966ZM48 59.3966L56.9333 50.6393C57.4812 50.1077 57.9169 49.4718 58.2149 48.769C58.5129 48.0662 58.6671 47.3108 58.6683 46.5475C58.6695 45.7841 58.5178 45.0282 58.2221 44.3245C57.9265 43.6207 57.4928 42.9834 56.9467 42.45C55.833 41.359 54.3369 40.7466 52.7779 40.7436C51.2189 40.7406 49.7205 41.3472 48.6027 42.434L48.0053 43.0206L47.4107 42.434C46.2971 41.3438 44.8016 40.7319 43.2433 40.7289C41.6849 40.7259 40.187 41.332 39.0693 42.418C38.5213 42.9494 38.0854 43.5852 37.7871 44.2879C37.4889 44.9906 37.3345 45.7459 37.333 46.5093C37.3315 47.2726 37.483 48.0285 37.7785 48.7324C38.0739 49.4362 38.5074 50.0738 39.0533 50.6073L48 59.3966Z",
    stroke: "#FFB85C",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpathy);
export default __webpack_public_path__ + "static/media/empathy.3c77cff8d5b2d34426294827a827e3e9.svg";
export { ForwardRef as ReactComponent };